// utils/syncOfflineLabs.js
import axios from "axios";
import { env } from "../constants/env";
import { db } from "./offlineDB";

export const syncOfflineLabs = async () => {
  if (!navigator.onLine) return;

  const labs = await db.offlineLabs.toArray();

  console.log("CHECKING ALL LABS", labs)

  for (const lab of labs) {
    const { id, offline, timestamp, lastSynced, ...payload } = lab;

    const localIsNewer =
      !lastSynced || new Date(timestamp) > new Date(lastSynced);

    if (!offline && !localIsNewer) continue;

    try {
      const res = await axios.put(
        `${env.kataApiUrl}/api/profile/${id}`,
        payload
      );

      await db.offlineLabs.update(id, {
        offline: false,
        lastSynced: new Date().toISOString(),
        ...res.data.data,
      });

      console.log(`[SYNC] Lab ${id} synced`);
    } catch (err) {
      console.error(`[SYNC] Lab ${id} failed`, err.message);
    }
  }
};